import { Component } from 'react';
import { Calendar, TimeInput } from 'react-widgets';
import Localization from 'react-widgets/Localization';
import { DateLocalizer } from 'react-widgets/IntlLocalizer';
import { formatDate } from '../../helpers/timezone';

import { ReactComponent as MenuButtonSVG } from '../../icons/table/menu-button.svg';
import { ReactComponent as QuestionMarkSVG } from '../../icons/question-mark.svg';

const local = {
  label: 'French',
  culture: 'fr',
  firstOfWeek: 1,
};

class TableCellDatetimeSinglePick extends Component {
  state = {
    showDropdown: false,
    date: this.props.date || undefined,
  };

  onToggleDropdown() {
    const { showDropdown } = this.state;
    this.setState({ showDropdown: !showDropdown });
  }

  onDateChange(value) {
    this.setState({ date: value });
  }

  onUpdate() {
    const { date } = this.state;
    this.props.onDateUpdate({ date });
    this.setState({ showDropdown: false });
  }

  render() {
    const { label } = this.props;
    const { date, showDropdown } = this.state;

    return (
      <div className="th-list-data pointer" id="th-cell-header">
        <div
          className="flex items-center justify-between"
          onClick={() => this.onToggleDropdown()}
        >
          <div>
            {label && <h3 className="ma0 pa0 th-members-list-name">{label}</h3>}
            {date ? (
              <p className="apps-card-app-desc">{formatDate(date)}</p>
            ) : (
              <p className="apps-card-app-desc">Not set</p>
            )}
          </div>
          <MenuButtonSVG />
        </div>

        {showDropdown && (
          <div
            className="th-select-filter-dropdown"
            style={{
              minWidth: '300px',
              width: document.getElementById('th-cell-header').offsetWidth,
              marginRight: '0',
              // marginTop:
              //   document.getElementById("th-cell-header").offsetHeight - 61,
            }}
          >
            <div className="pr5 pl5 flex justify-between ">
              <div className="mt2 flex flex-column items-center">
                {label && (
                  <h3 className="flex items-center pa0 th-members-list-name">
                    {label}
                    <QuestionMarkSVG data-rh="All time in the web app is in CET." />
                  </h3>
                )}
                <Localization date={new DateLocalizer(local)}>
                  <Calendar
                    bordered={false}
                    value={date}
                    onChange={(value) => this.onDateChange(value)}
                  />
                  <TimeInput
                    style={{ width: 'auto' }}
                    datePart={date}
                    value={date}
                    onChange={(value) => this.onDateChange(value)}
                  />
                </Localization>
              </div>
            </div>
            <div className="tc mb2 mt4">
              <button className="btn-green" onClick={() => this.onUpdate()}>
                <span>Update</span>
              </button>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default TableCellDatetimeSinglePick;
